import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SolutionsSection() {
  const solutions = [<>
      Saber <span className="font-bold" data-id="element-162">exactamente</span> qué comer todos los
      días
    </>, <>
      Comer rico{' '}
      <span className="font-bold underline decoration-primary/40 decoration-2 underline-offset-2" data-id="element-163">
        sin azúcar ni harina
      </span>{' '}
      <span className="bg-yellow-200/60 px-1 rounded font-medium" data-id="element-164">
        (sin sufrir)
      </span>
    </>, <>
      Sentirte más{' '}
      <span className="font-bold underline decoration-primary/40 decoration-2 underline-offset-2" data-id="element-165">
        liviana, desinflamada y con energía
      </span>
    </>, <>
      Dejar de picar cualquier cosa por{' '}
      <span className="font-bold" data-id="element-166">ansiedad</span>
    </>, <>
      Disfrutar{' '}
      <span className="font-bold bg-yellow-200/60 px-1 rounded" data-id="element-167">sin culpa</span>
    </>, <>
      Dejar de pensar en comida… porque{' '}
      <span className="font-bold underline decoration-accent decoration-2 underline-offset-2" data-id="element-168">
        ya lo tenés resuelto
      </span>
      .
    </>];
  const images = ['https://images.unsplash.com/photo-1512621776951-a57141f2eefd?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=2080&auto=format&fit=crop', 'https://cdn.magicpatterns.com/uploads/9vVqSJ7YZXW9eiHRr4mQb6/Captura_de_pantalla_2026-04-11_a_la(s)_10.38.35_a._m..png', 'https://cdn.magicpatterns.com/uploads/o3oeTYDQkXMW9PJdsPjv6V/Captura_de_pantalla_2026-04-11_a_la(s)_10.38.23_a._m..png'];
  return <section className="py-16 md:py-24 px-4" data-id="element-169">
      <div className="max-w-4xl mx-auto" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-171">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6" data-id="element-172">
            365 DÍAS SIN PENSAR "¿QUÉ COMO HOY?"
          </h2>
          <p className="text-xl md:text-2xl text-gray-700 font-medium max-w-2xl mx-auto" data-id="element-173">
            No te falta{' '}
            <span className="font-bold underline decoration-primary/40 decoration-2 underline-offset-2" data-id="element-174">
              disciplina
            </span>
            . Te falta{' '}
            <span className="font-bold underline decoration-accent decoration-2 underline-offset-2" data-id="element-175">
              claridad
            </span>
            . <br className="hidden md:block" data-id="element-176" />
            <span className="text-charcoal font-bold" data-id="element-177">
              Y eso es exactamente lo que este recetario te da.
            </span>
          </p>
        </motion.div>

        {/* Image Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16" data-id="element-178">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="rounded-xl overflow-hidden shadow-md aspect-square" data-id="element-179">
              <img src={img} alt="Plato saludable" className="w-full h-full object-cover hover:scale-110 transition-transform duration-500" data-id="element-180" />
            </motion.div>)}
        </div>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-gray-100" data-id="element-181">
          <h3 className="text-2xl md:text-3xl font-bold text-charcoal mb-8 text-center" data-id="element-182">
            A lo largo de este proceso vas a lograr:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-183">
            {solutions.map((solution, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start space-x-3" data-id="element-184">
                <CheckCircle2 className="text-solution flex-shrink-0 mt-1" size={24} data-id="element-185" />
                <p className="text-lg text-gray-800 font-medium" data-id="element-186">{solution}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-187">
            <CTAButton data-id="element-188">QUIERO MI RECETARIO</CTAButton>
          </div>
        </div>
      </div>
    </section>;
}